export const environment = {
  production: true,
  name: 'stage',
  webUrl: 'https://uat.nonprod.mobile.bdadvanced.spglobal.com',
  baseUrl: 'https://backend.bda-mobile.nonprod.bdadvanced.ihsmarkit.com',
  apiUrl:
    'https://backend.bda-mobile.nonprod.bdadvanced.ihsmarkit.com/mobile/api',
};
